import { Rxios } from 'rxios'

import { BASEURL } from '../constants'

export const rxios = new Rxios({
  baseURL: BASEURL,
})
